import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { DefaultContentLayout } from "../shared/Layout";
import { CampaignList } from "./CampaignList";
import { CampaignUrlList } from "./CampaignUrlList";

export const CampaignPage: FC = () => {
	return (
		<Routes>
			<Route
				index
				element={
					<DefaultContentLayout>
						<CampaignList />
					</DefaultContentLayout>
				}
			/>
			<Route
				path=":id"
				element={
					<DefaultContentLayout>
						<CampaignUrlList />
					</DefaultContentLayout>
				}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
